import dynamic from 'next/dynamic';

import type { HighlightIconText } from '@/components/HighlightMediaText/HighlightMediaText';
import type { TextContentAppLinks } from '@/components/HighlightMediaText/TextContent/TextContent';
import type { ImageSources } from '@/components/Image/ArtDirectedImage';
import type { ButtonContent } from '@/components/OldButton/OldButton';
import type { VimeoVideoType } from '@/components/VimeoVideo/VimeoVideo';

import ImageFull from './ImageFull';

const VideoFull = dynamic(() => import('./VideoFull'), { ssr: false });

export interface HighlightMediaTextProps {
  isMobile: boolean;
  imageSources?: ImageSources;
  mobileImageAspectRatio?: string;
  video?: VimeoVideoType;
  isOnDark: boolean;
  isRightAligned: boolean;
  subhead?: string;
  features?: HighlightIconText[];
  cta?: ButtonContent[];
  isHeroMode?: boolean;
  eyebrow?: string;
  headline?: string;
  imageAltText?: string;
  appLinks?: TextContentAppLinks;
}

const HighlightMediaTextFull = (props: HighlightMediaTextProps) => {
  const { video } = props;
  const hasVideo = video?.fields?.videoUrl;

  return hasVideo ? <VideoFull {...props} /> : <ImageFull {...props} />;
};

export default HighlightMediaTextFull;
